import React, { FC } from 'react';
import poReports1 from '../../../assets/help/purchaseOrderReports/po_reports_1.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpBullet, HelpImage, HelpIndent, HelpStep, HelpTitle } from './HelpElements';

const PurchaseOrderReportsHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('purchaseOrderReportsHelp');

    return (
        <>
            <HelpTitle>{t('purchaseOrderReportsHelp_Title')}</HelpTitle>
            <HelpBody>{t('purchaseOrderReportsHelp_intro')}</HelpBody>
            <HelpStep step={1}>{t('purchaseOrderReportsHelp_step1')}</HelpStep>
            <HelpImage size={'medium'} src={poReports1} />
            <HelpIndent>
                <HelpBullet>{t('purchaseOrderReportsHelp_step1_navigate')}</HelpBullet>
                <HelpIndent>
                    <HelpBullet level={1}>{t('purchaseOrderReportsHelp_step1_createContacts')}</HelpBullet>
                    <HelpBullet level={1}>{t('purchaseOrderReportsHelp_step1_viewContacts')}</HelpBullet>
                    <HelpBullet level={1}>{t('purchaseOrderReportsHelp_step1_selectReseller')}</HelpBullet>
                </HelpIndent>
            </HelpIndent>
            <HelpStep step={2}>{t('purchaseOrderReportsHelp_step2')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('purchaseOrderReportsHelp_step2_create')}</HelpBullet>
                <HelpBullet>{t('purchaseOrderReportsHelp_step2_signup')}</HelpBullet>
            </HelpIndent>
            <HelpStep step={3}>{t('purchaseOrderReportsHelp_step3')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('purchaseOrderReportsHelp_step3_view')}</HelpBullet>
                <HelpBullet>{t('purchaseOrderReportsHelp_step3_delete')}</HelpBullet>
                <HelpBullet>{t('purchaseOrderReportsHelp_step3_modify')}</HelpBullet>
            </HelpIndent>
            <HelpStep step={4}>{t('purchaseOrderReportsHelp_step4')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('purchaseOrderReportsHelp_step4_select')}</HelpBullet>
            </HelpIndent>
        </>
    );
};

export { PurchaseOrderReportsHelp };
